module.exports = __webpack_public_path__ + "static/tafheem-banner-08803be80bd085180a6fd48bdd1608e6.png";